import React from 'react';

import BookmarkList from '../components/bookmark/bookmark-list';
import BookmarkTitle from '../components/bookmark/bookmark-title';
import BookmarkTop from '../components/bookmark/bookmark-top';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BookmarkProvider } from '../context/bookmark/df-bookmark-provider';
import Grid from '../components/grid';
import ErrorBoundary from '../api/error-boundary';

const client = new QueryClient();
export default function DfBookmarks(): React.ReactElement {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={client}>
        <BookmarkProvider>
          <BookmarkTitle />
          <Grid>
            <BookmarkTop />
            <BookmarkList />
          </Grid>
        </BookmarkProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
